import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";

export default function AddUserDialog({ open, onOpenChange, newUser, setNewUser, onSubmit }) {
  const set = (k, v) => setNewUser({ ...newUser, [k]: v });
  const [types, setTypes] = useState([]);
  useEffect(() => {
    if (open) api.get("/admin/affiliate-types").then((r) => setTypes(r.data));
  }, [open]);

  const isAffiliate = newUser.role === "affiliate";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button data-testid="btn-add-user" className="rounded-full bg-pink-500 hover:bg-pink-400 text-black h-11">
          <Plus className="w-4 h-4 mr-2" strokeWidth={2} /> Add user
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-[#22103F] border-white/10 text-white max-w-lg">
        <DialogHeader><DialogTitle>Add user manually</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2 max-h-[65vh] overflow-y-auto pr-1">
          <div>
            <Label className="text-slate-300">Name</Label>
            <Input data-testid="input-new-name" value={newUser.name} onChange={(e) => set("name", e.target.value)} className="velo-input mt-2" />
          </div>
          <div>
            <Label className="text-slate-300">Phone</Label>
            <Input data-testid="input-new-phone" value={newUser.phone} onChange={(e) => set("phone", e.target.value)} className="velo-input mt-2 font-mono" />
          </div>
          <div>
            <Label className="text-slate-300">Role</Label>
            <Select value={newUser.role} onValueChange={(v) => set("role", v)}>
              <SelectTrigger className="velo-input mt-2"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#22103F] border-white/10 text-white">
                <SelectItem value="customer">Customer</SelectItem>
                <SelectItem value="affiliate">Affiliate</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {isAffiliate ? (
            <>
              <div>
                <Label className="text-slate-300">Affiliate type <span className="text-red-400">*</span></Label>
                <Select value={newUser.affiliate_type || ""} onValueChange={(v) => set("affiliate_type", v)}>
                  <SelectTrigger data-testid="select-affiliate-type" className="velo-input mt-2"><SelectValue placeholder="Select type…" /></SelectTrigger>
                  <SelectContent className="bg-[#22103F] border-white/10 text-white">
                    {types.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label className="text-slate-300">Associate firm <span className="text-slate-500 text-xs">(optional)</span></Label>
                <Input data-testid="input-associate-firm" value={newUser.associate_firm || ""} onChange={(e) => set("associate_firm", e.target.value)} placeholder="e.g. Star Motors Kochi" className="velo-input mt-2" />
              </div>
            </>
          ) : null}
          <div>
            <Label className="text-slate-300">Referred by (referral code)</Label>
            <Input data-testid="input-new-ref" value={newUser.referral_code_used} onChange={(e) => set("referral_code_used", e.target.value.toUpperCase())} placeholder="Optional" className="velo-input mt-2 font-mono" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="btn-submit-new-user" onClick={onSubmit} className="rounded-full bg-pink-500 hover:bg-pink-400 text-black">Create user</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
